var map = {
	"./excle-color.png": "b66a",
	"./file-color.png": "057d",
	"./image-color.png": "05cd",
	"./music-color.png": "dd8d",
	"./ppt-color.png": "126f",
	"./text-color.png": "834a",
	"./video-color.png": "81dd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8702";